import { Model } from "@shared-features/models/model";
import { Expose } from "class-transformer";

export class OtpResponse extends Model {
  @Expose() message!: string;
  @Expose() cooldownSeconds!: number;
  @Expose() requiresRecaptchaV2?: boolean;
  @Expose() code?: string;
}